import { render, staticRenderFns } from "./Produto.vue?vue&type=template&id=17011492&scoped=true"
import script from "./Produto.vue?vue&type=script&lang=js"
export * from "./Produto.vue?vue&type=script&lang=js"
import style0 from "./Produto.vue?vue&type=style&index=0&id=17011492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17011492",
  null
  
)

export default component.exports